import { Loader, PriceString } from '@fourthwall/components';
import { SelectPaymentMethod } from '@modules/Dashboard/modules/PaymentMethods';
import React from 'react';
import { TermsFooter } from '../TermsFooter/TermsFooter';
import * as S from './PaymentStage.styled';
export const PaymentStage = ({ total, onSuccess, onAddPaymentMethodClose }) => {
    return (React.createElement(SelectPaymentMethod, { onSuccess: onSuccess, onAddPaymentMethodClose: onAddPaymentMethodClose, submitLabel: "Pay now", withChargeLimit: false }, ({ isLoading, renderSubmitButton, renderContent }) => (React.createElement(React.Fragment, null,
        isLoading && (React.createElement(S.LoaderWrapper, null,
            React.createElement(Loader, { size: "large" }))),
        React.createElement(S.Content, null,
            !isLoading && React.createElement(S.SecondaryText, null, "Payment method"),
            React.createElement(S.PaymentMethodsContainer, null,
                React.createElement(S.PaymentMethodsWrapper, null, renderContent()))),
        React.createElement(S.TotalSummaryContainer, null,
            React.createElement("span", null, "Total to pay"),
            React.createElement("span", null,
                React.createElement(PriceString, { ...total }))),
        renderSubmitButton(),
        React.createElement(TermsFooter, null)))));
};
